


















import Vue from 'vue';
import Header from './Header.vue';
import Footer from './Footer.vue';

export default Vue.extend({
    components: {
        Footer: Footer,
        Header: Header,
    },
});
